;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { RumData } from '@qogita/ui/providers/real-user-monitoring'
import posthog from 'posthog-js'

import { posthogConfig } from './config'

export function capturePosthogAction(name: string, data?: RumData) {
  if (!posthogConfig.enabled) return
  posthog.capture(name, data ?? {})
}
